if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

/* ######################### */
/* ######################### */
/* ######################### */
/* ######################### */
/* ######################### */

// STEP 3 RADIO BUTTON FIX - Complete Solution
// Fix for Shopify configurator where Step 3 selections are not included in orders

(function() {
    'use strict';
    
    console.log('🔧 Step 3 Radio Fix Loading...');
    
    // Configuration
    const CONFIG = {
        // Tobias edit (Sprache): Schlagworte zusätzlich in der aktuellen Shop-Sprache,
        // damit die Erkennung der Step-3-Auswahl auch im FR-/EN-Shop greift
        // alt: step3Keywords: ['Wand', 'Tür', 'Glas', 'wand', 'tür', 'glas'],
        step3Keywords: (function () {
            var keywords = ['Wand', 'Tür', 'Glas'];
            if (typeof pwPropValue === 'function') {
                keywords = keywords.concat([pwPropValue('wall'), pwPropValue('door'), pwPropValue('glass')]);
            }
            return keywords.concat(keywords.map(function (keyword) { return keyword.toLowerCase(); }));
        })(),
        // Tobias edit (Sprache): Property-Name in der aktuellen Shop-Sprache
        // (Fallback Deutsch, falls der Konfigurator nicht geladen ist)
        // alt: propertyName: 'properties[Oberflächenart]', // Surface type in German
        propertyName: typeof pwPropName === 'function' ? pwPropName('surface') : 'properties[Oberflächenart]',
        debugMode: true
    };
    
    let step3Selection = null;
    
    // 1. FIX DUPLICATE IDs - This is critical!
    function fixDuplicateIds() {
        console.log('🔧 Fixing duplicate radio button IDs...');
        
        const compactButtons = document.querySelectorAll('.compact-button');
        compactButtons.forEach((button, index) => {
            const radio = button.querySelector('input[type="radio"]');
            const label = button.querySelector('label');
            
            if (radio && label) {
                // Create unique ID for each radio button
                const uniqueId = `step3-option-${index}-${Date.now()}`;
                radio.id = uniqueId;
                label.setAttribute('for', uniqueId);
                
                // Fix the value to match the label text
                const labelText = label.textContent.trim();
                radio.value = labelText;
                
                // Ensure all radios have the same name for proper grouping
                radio.name = 'step3_surface_type';
                
                console.log(`✅ Fixed radio ${index}: ID=${uniqueId}, Value=${labelText}`);
            }
        });
    }
    
    // 2. SETUP PROPER EVENT LISTENERS
    function setupStep3Listeners() {
        console.log('📡 Setting up Step 3 event listeners...');
        
        // Use event delegation on the wrapper
        const wrapper = document.querySelector('.compact-buttons-wrapper');
        if (!wrapper) {
            console.error('❌ .compact-buttons-wrapper not found!');
            return;
        }
        
        wrapper.addEventListener('click', function(event) {
            const button = event.target.closest('.compact-button');
            if (!button) return;
            
            const radio = button.querySelector('input[type="radio"]');
            const label = button.querySelector('label');
            
            if (radio && label) {
                // Manually check the radio (since click might not work with duplicate IDs)
                radio.checked = true;
                
                // Update visual state
                document.querySelectorAll('.compact-button').forEach(btn => 
                    btn.classList.remove('swatch-selected'));
                button.classList.add('swatch-selected');
                
                // Store selection
                step3Selection = {
                    value: label.textContent.trim(),
                    element: radio
                };
                
                console.log('🎯 Step 3 selection:', step3Selection.value);
                
                // Trigger change event
                radio.dispatchEvent(new Event('change', { bubbles: true }));
                
                // Update form immediately
                updateProductForm();
            }
        });
        
        // Also listen for actual radio changes
        wrapper.addEventListener('change', function(event) {
            if (event.target.type === 'radio') {
                const label = event.target.parentElement.querySelector('label');
                if (label) {
                    step3Selection = {
                        value: label.textContent.trim(),
                        element: event.target
                    };
                    console.log('📻 Radio change detected:', step3Selection.value);
                    updateProductForm();
                }
            }
        });
    }
    
    // 3. UPDATE PRODUCT FORM WITH STEP 3 SELECTION
    function updateProductForm() {
        if (!step3Selection) {
            console.log('⚠️ No Step 3 selection to add to form');
            return;
        }
        
        const productForm = document.querySelector('product-form form') || 
                          document.querySelector('form[action*="cart/add"]');
        
        if (!productForm) {
            console.error('❌ Product form not found');
            return;
        }
        
        // Remove existing Step 3 property
        const existingProperty = productForm.querySelector(`input[name="${CONFIG.propertyName}"]`);
        if (existingProperty) {
            existingProperty.remove();
        }
        
        // Add new hidden input with Step 3 selection
        const hiddenInput = document.createElement('input');
        hiddenInput.type = 'hidden';
        hiddenInput.name = CONFIG.propertyName;
        hiddenInput.value = step3Selection.value;
        hiddenInput.setAttribute('data-step3-property', 'true');
        
        productForm.appendChild(hiddenInput);
        
        console.log(`✅ Added to form: ${CONFIG.propertyName} = ${step3Selection.value}`);
        
        if (CONFIG.debugMode) {
            // Show current form state
            const formData = new FormData(productForm);
            console.group('📋 Current Form Data:');
            for (let [key, value] of formData.entries()) {
                console.log(`${key}: ${value}`);
            }
            console.groupEnd();
        }
    }
    
    // 4. ENHANCE FORM SUBMISSION
    function enhanceFormSubmission() {
        const productFormElement = document.querySelector('product-form');
        
        if (!productFormElement) {
            console.warn('⚠️ Product form element not found');
            return;
        }
        
        // Store original submit handler
        const originalHandler = productFormElement.onSubmitHandler;
        
        if (typeof originalHandler !== 'function') {
            console.warn('⚠️ Original submit handler not found');
            return;
        }
        
        // Override with enhanced handler
        productFormElement.onSubmitHandler = function(evt) {
            console.group('🚀 ENHANCED FORM SUBMISSION');
            
            // Ensure Step 3 selection is captured and added
            captureCurrentStep3Selection();
            updateProductForm();
            
            // Validate Step 3 is included
            const formData = new FormData(this.form);
            let step3Found = false;
            
            for (let [key, value] of formData.entries()) {
                console.log(`📤 ${key}: ${value}`);
                
                if (key === CONFIG.propertyName || 
                    CONFIG.step3Keywords.some(keyword => value.includes(keyword))) {
                    step3Found = true;
                    console.log('✅ Step 3 data confirmed in submission!');
                }
            }
            
            if (!step3Found) {
                console.error('❌ CRITICAL: Step 3 data missing from submission!');
                // Try emergency capture
                emergencyStep3Capture();
                updateProductForm();
            }
            
            console.groupEnd();
            
            // Call original handler
            return originalHandler.call(this, evt);
        };
        
        console.log('✅ Form submission enhanced');
    }
    
    // 5. CAPTURE CURRENT SELECTION
    function captureCurrentStep3Selection() {
        // Check for visually selected button
        const selectedButton = document.querySelector('.compact-button.swatch-selected');
        if (selectedButton) {
            const label = selectedButton.querySelector('label');
            if (label) {
                step3Selection = {
                    value: label.textContent.trim(),
                    element: selectedButton.querySelector('input[type="radio"]')
                };
                console.log('🎯 Captured selected button:', step3Selection.value);
                return;
            }
        }
        
        // Check for checked radio in Step 3 area
        const step3Radios = document.querySelectorAll('.compact-buttons-wrapper input[type="radio"]');
        step3Radios.forEach(radio => {
            if (radio.checked) {
                const label = radio.parentElement.querySelector('label');
                if (label) {
                    step3Selection = {
                        value: label.textContent.trim(),
                        element: radio
                    };
                    console.log('📻 Captured checked radio:', step3Selection.value);
                }
            }
        });
    }
    
    // 6. EMERGENCY CAPTURE
    function emergencyStep3Capture() {
        console.log('🚨 Emergency Step 3 capture...');
        
        // Try multiple methods to find the selection
        const methods = [
            // Method 1: Look for selected/active elements
            () => {
                const selected = document.querySelector('.swatch-selected label, .active label, .selected label');
                return selected ? selected.textContent.trim() : null;
            },
            
            // Method 2: Look for checked radios with Step 3 keywords
            () => {
                const radios = document.querySelectorAll('input[type="radio"]:checked');
                for (let radio of radios) {
                    const label = radio.parentElement.querySelector('label');
                    if (label) {
                        const text = label.textContent.trim();
                        if (CONFIG.step3Keywords.some(keyword => text.includes(keyword))) {
                            return text;
                        }
                    }
                }
                return null;
            },
            
            // Method 3: Default to first option if nothing else works
            () => {
                const firstLabel = document.querySelector('.compact-buttons-wrapper label');
                // Tobias edit (Sprache): Fallback-Wert in der aktuellen Shop-Sprache
                // alt: return firstLabel ? firstLabel.textContent.trim() : 'Wand';
                return firstLabel ? firstLabel.textContent.trim() : (typeof pwPropValue === 'function' ? pwPropValue('wall') : 'Wand');
            }
        ];
        
        for (let method of methods) {
            const result = method();
            if (result) {
                step3Selection = { value: result, element: null };
                console.log('✅ Emergency capture successful:', result);
                return;
            }
        }
    }
    
    // 7. INITIALIZE
    function init() {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', init);
            return;
        }
        
        console.log('🚀 Initializing Step 3 fix...');
        
        // Wait for custom elements to be ready
        setTimeout(() => {
            fixDuplicateIds();
            setupStep3Listeners();
            enhanceFormSubmission();
            captureCurrentStep3Selection();
            
            // Set up periodic validation
            setInterval(() => {
                if (!step3Selection) {
                    captureCurrentStep3Selection();
                    updateProductForm();
                }
            }, 3000);
            
            console.log('✅ Step 3 fix initialized successfully');
            
        }, 1000);
    }
    
    // 8. DEBUGGING HELPERS
    window.debugStep3Fix = function() {
        console.group('🔍 STEP 3 DEBUG');
        console.log('Current selection:', step3Selection);
        
        console.log('Compact buttons found:', document.querySelectorAll('.compact-button').length);
        console.log('Radio buttons found:', document.querySelectorAll('.compact-buttons-wrapper input[type="radio"]').length);
        
        captureCurrentStep3Selection();
        updateProductForm();
        
        console.groupEnd();
    };
    
    window.forceStep3Selection = function(value) {
        // Tobias edit (Sprache): Default-Wert in der aktuellen Shop-Sprache
        // alt: step3Selection = { value: value || 'Wand', element: null };
        step3Selection = { value: value || (typeof pwPropValue === 'function' ? pwPropValue('wall') : 'Wand'), element: null };
        updateProductForm();
        console.log('✅ Forced Step 3 selection:', step3Selection.value);
    };
    
    // Start the fix
    init();
    
})();

// ADDITIONAL FORM VALIDATION
document.addEventListener('submit', function(event) {
    if (event.target && event.target.action && event.target.action.includes('cart/add')) {
        console.group('🔍 FINAL FORM VALIDATION');
        
        const formData = new FormData(event.target);

        // Tobias edit (Sprache): Property-Name der Oberflächenart in der aktuellen
        // Shop-Sprache (Fallback Deutsch, falls der Konfigurator nicht geladen ist)
        const surfaceLabel = typeof pwPropLabel === 'function' ? pwPropLabel('surface') : 'Oberflächenart';
        const surfacePropertyName = 'properties[' + surfaceLabel + ']';
        let hasStep3 = false;
        let hasVariantId = false;
        
        for (let [key, value] of formData.entries()) {
            console.log(`📝 ${key}: ${value}`);
            
            // Tobias edit (Sprache): Property-Name in der aktuellen Shop-Sprache
            // alt: if (key === 'properties[Oberflächenart]' || key.includes('Oberflächenart')) {
            if (key === surfacePropertyName || key.includes(surfaceLabel)) {
                hasStep3 = true;
                console.log('✅ Step 3 property found!');
            }
            
            if (key === 'id' && value && value !== '') {
                hasVariantId = true;
                console.log('✅ Variant ID found!');
            }
        }
        
        if (!hasStep3) {
            console.error('❌ CRITICAL: Step 3 data missing from final submission!');
        }
        
        if (!hasVariantId) {
            console.error('❌ CRITICAL: Variant ID missing from submission!');
        }
        
        console.groupEnd();
    }
});

console.log('✅ Step 3 Radio Fix Loaded Successfully');
